import { AgeCategory, ClientType } from 'constants/constants';

// 年齢を取得
export function getAge(birthday) {
  if (!birthday) {
    return -1;
  }

  // 現在の日付を取得
  const today = new Date();

  // 生年月日から年齢を計算
  const birthDate = new Date(birthday);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  // 誕生日がまだ来ていない場合は年齢を1減らす
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

// 年齢・月・日から生年月日の「年」を計算する
export function getBirthYearFromAge(age, birthMonth, birthDay) {
  if (age == null || age < 0 || birthMonth == null || birthDay == null) {
    return null;
  }

  const today = new Date();
  const thisYearBirthday = new Date(today.getFullYear(), birthMonth - 1, birthDay); // 月は0始まり

  let birthYear = today.getFullYear() - age;

  // 誕生日がまだ来ていない場合は年を1つ下げる
  if (today < thisYearBirthday) {
    birthYear -= 1;
  }
  return birthYear;
}

// 年代を取得
export function getAgeCategory(birthday, userType, ageCategory) {
  // 法人の場合
  if (userType == ClientType.CORP) {
    return AgeCategory.AGE_CORP;
  }
  // 公共の場合
  if (userType == ClientType.PUBLIC) {
    return AgeCategory.AGE_PUBLIC;
  }

  // 年代に指定がある場合はその年代を返す
  if (ageCategory !== undefined) {
    return ageCategory;
  }

  let age = getAge(birthday);

  if (!birthday || age < 10) {
    return 0;
  }
  // 年代を判定
  if (age >= 10 && age < 40) {
    return AgeCategory.AGE_20;
  } else if (age >= 40 && age < 60) {
    return AgeCategory.AGE_40;
  } else if (age >= 60) {
    return AgeCategory.AGE_60;
  }
}
